export default __webpack_public_path__ + "static/media/KZ.T.16.1095 black.69c6ccdc.svg";